function isSpa() {
	return window.IS_SPA;
}

export default isSpa;



// WEBPACK FOOTER //
// ./src/shared/util/isSpa.js